// You can put this in a separate file: src/app/core/lcid-mapping.ts
export const LCID_TO_LANG: Record<number, string> = {
  // Primary ones from your list
  1025: 'ar-SA',     // Arabic - Saudi Arabia
  1026: 'bg-BG',     // Bulgarian - Bulgaria
  1028: 'zh-TW',     // Chinese - Traditional (Taiwan)
  1029: 'cs-CZ',     // Czech - Czech Republic
  1030: 'da-DK',     // Danish - Denmark
  1031: 'de-DE',     // German - Germany
  1032: 'el-GR',     // Greek - Greece
  1033: 'en-US',     // English - United States
  1035: 'fi-FI',     // Finnish
  1036: 'fr-FR',     // French - France
  1037: 'he-IL',     // Hebrew - Israel
  1038: 'hu-HU',     // Hungarian
  1040: 'it-IT',     // Italian - Italy
  1041: 'ja-JP',     // Japanese
  1042: 'ko-KR',     // Korean
  1043: 'nl-NL',     // Dutch - Netherlands
  1044: 'no-NO',     // Norwegian (Bokmål)
  1045: 'pl-PL',     // Polish
  1046: 'pt-BR',     // Portuguese - Brazil
  1048: 'ro-RO',     // Romanian
  1049: 'ru-RU',     // Russian
  1050: 'hr-HR',     // Croatian
  1051: 'sk-SK',     // Slovak
  1053: 'sv-SE',     // Swedish
  1054: 'th-TH',     // Thai
  1055: 'tr-TR',     // Turkish
  1057: 'id-ID',     // Indonesian
  1060: 'sl-SI',     // Slovenian
  1063: 'lt-LT',     // Lithuanian
  1068: 'AZ', // Azerbaijani (Latin)
  1106: 'cy-GB',     // Welsh
  2052: 'zh-CN',     // Chinese - Simplified (PRC)
  2057: 'en-GB',     // English - United Kingdom   ← very common default
  2070: 'pt-PT',     // Portuguese - Portugal
  2074: 'sr', // Serbian (Latin) - older, nowadays mostly sr-Latn-RS
  3082: 'es-ES',     // Spanish - Spain (Modern Sort)
  3084: 'fr-CA',     // French - Canada

  // Some extended/variant codes from your list
  11031: 'de-IN',    // German - Switzerland (example mapping)
  11033: 'gv-US',    // English - Australia (example)
  11038: 'hu-IN',    // French - Switzerland
  11043: 'nl-IN',    // German - Austria
  11050: 'hr-IN',    // Spanish - Mexico (common)  
  11060: 'sl-IN',    // French - Belgium
  12057: 'gg-GB',    // Arabic - Egypt (example)
  12074: 'sr-IN',    // Spanish - Argentina
  13082: 'es-IN',    // Spanish - Chile (example)
  21033: 'er-US',    // Greek - Cyprus (example)

  // Add missing ones from your list when you know the exact variant
  // 1032 → el-GR (Greek)
  // 11031, 11033, 11038, 11043, 11050, 11051, 11060, 12057, 12074, 13082, 21033 → need exact context
  // Many of these are regional variants of the main language
};